// extracted by mini-css-extract-plugin
export default {"row":"CrearPlan_row__7DZQY","col":"CrearPlan_col__wbUwa","card":"CrearPlan_card__HDKp9"};